import {  Col, Divider, Row, Typography } from "antd";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { Helmet } from "react-helmet-async";



const ContactUsIndex = () => {
  const { Text } = Typography;
  return (
    <>
 
      <Col xs={24}>
        <Row gutter={[20, 20]}>
          <Col xs={24} >
          <StaticPageBanner
              title="Bizimle İletişime Geçiniz"
              description="Görüşleriniz bize yardımcı olur."
            />
             <Helmet>
                                <title className="capitalize">{"İletişim"}</title>
                          </Helmet>
           
          </Col>
          
          <Col xs={24}>
            <Row gutter={[20, 20]} className="!px-2 lg:!px-6 xxl:!px-16">
              <Col span={24}>
                <div>
                  <Text className="!text-xl !font-bold">Merkez Adres</Text>
                </div>
                <div>
                  <Text className="!text-xs !text-[#6E7583]">
                    AKDENİZ MAH. ŞEHİT FETHİ BEY CAD. HERİS TOWER NO:55/091
                    KONAK/İZMİR
                  </Text>
                </div>
              </Col>
              <Col xs={24}>
                <Divider className="!m-0" />
              </Col>
              <Col xs={24}>
                <Row gutter={[20, 20]} >
                  <Col span={24}>
                    <div>
                      <Text className="!text-xl !font-bold">Telefon</Text>
                    </div>
                    <div>
                      <Text className="!text-xs !text-[#6E7583]">
                       4044444
                      </Text>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={24}>
                <Divider className="!m-0" />
              </Col>
              <Col xs={24}>
                <Row gutter={[20, 20]} >
                  <Col span={24}>
                    <div>
                      <Text className="!text-xl !font-bold">E-Posta</Text>
                    </div>
                    <div>
                      <Text className="!text-xs !text-[#6E7583]">
                       info@sariilanlar.com
                      </Text>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

    
    </>
  );
};

export default ContactUsIndex;
